import {UPDATE_AVAILABLE_CLAIMS, UPDATE_AVAILABLE_CLAIMS_STATUS, UPDATE_PLAYER_CLAIMS, UPDATE_PLAYER_CLAIMS_STATUS} from "Redux/actions/claims";

const claimsLoaded = !!window?.MORPHEUS?.account?.claims;
const initialPlayerClaims = claimsLoaded ? window.MORPHEUS.account.claims : [];

const initialState = {
    availableClaims: {
        claims: [],
        error: null,
        status: "idle",
        isLoaded: false
    },
    playerClaims: {
        claims: initialPlayerClaims,
        error: null,
        status: "idle",
        isLoaded: claimsLoaded
    }
};

const claimsReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_PLAYER_CLAIMS:
            return {...state, playerClaims: {...state.playerClaims, isLoaded: true, claims: action.newPlayerClaims}};
        case UPDATE_AVAILABLE_CLAIMS:
            return {...state, availableClaims: {...state.availableClaims, isLoaded: true, claims: action.newAvailableClaims}};
        case UPDATE_PLAYER_CLAIMS_STATUS:
            return {...state, playerClaims: {...state.playerClaims, status: action.status, error: action.error}};
        case UPDATE_AVAILABLE_CLAIMS_STATUS:
            return {...state, availableClaims: {...state.availableClaims, status: action.status, error: action.error}};
        default:
            return {...state};
    }
};

export default claimsReducer;
